var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg068Question(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 12C2 6.5 6.5 2 12 2C17.5 2 22 6.5 22 12C22 17.5 17.5 22 12 22C6.5 22 2 17.5 2 12ZM4 12C4 16.4 7.6 20 12 20C16.4 20 20 16.4 20 12C20 7.6 16.4 4 12 4C7.6 4 4 7.6 4 12ZM13 17C13 17.5523 12.5523 18 12 18C11.4477 18 11 17.5523 11 17C11 16.4477 11.4477 16 12 16C12.5523 16 13 16.4477 13 17ZM10.1 6.6C10.8 6.1 11.7 5.9 12.5 6C13.7 6.2 14.6 7.2 14.8 8.3C15 9.2 14.8 10 14.2 10.7C13.5 11.5 13.1 12.5 13 13.5V14C13 14.6 12.6 15 12 15C11.4 15 11 14.6 11 14V13.5C11.1 12 11.7 10.5 12.7 9.4C12.9 9.2 12.9 9 12.9 8.7C12.8 8.3 12.5 8.1 12.2 8C11.9 8 11.7 8 11.4 8.1C11.2 8.3 11.1 8.5 11.1 8.8C11.1 9.4 10.7 9.8 10.1 9.8C9.5 9.8 9.1 9.4 9.1 8.8C9.1 8 9.5 7.2 10.1 6.6Z",
    fill: "#8199A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg068Question);
export default __webpack_public_path__ + "static/media/068-question.bfc6b9f7bae4710ef7430870db94a097.svg";
export { ForwardRef as ReactComponent };